const character = {
  /**
   * 全形轉半形
   * @param {*} chars
   * @returns {String}
   */
  toASCII(chars) {
    if (!chars) return chars;
    var ascii = '';
    for (var i = 0, l = chars.length; i < l; i++) {
      var c = chars[i].charCodeAt(0);

      // make sure we only convert half-full width char
      if (c >= 0xff00 && c <= 0xffef) {
        c = 0xff & (c + 0x20);
      }

      ascii += String.fromCharCode(c);
    }

    return ascii;
  },
};

export default character;
